export default __webpack_public_path__ + "static/media/AmazonEmber_W_Rg.a15450d3.woff2";